import { IBase } from './base.interface';
import { IPack } from './catalog';
import { OrderMode } from '@tickeat/types';

export enum LoyaltyType {
  LEVEL = 'LEVEL',
  DISCOUNT = 'DISCOUNT',
}

export enum LoyaltyEarningMode {
  ITEM = 'ITEM',
  EURO = 'EURO',
}

interface Loyalty extends IBase {
  type: LoyaltyType;

  disabled: boolean;

  isUsableOnPOS: boolean;

  // description: string;

  maxPoints?: number;

  minPrice?: number;

  daysWithoutOrderUntilReset?: number;

  exchangeRateForOneEuro: number;

  roundPointsUp?: boolean;

  earningMode: LoyaltyEarningMode;

  orderModes: OrderMode[];

  usableOnlyOnNextOrder: boolean;

  byShop: boolean;

  cumulative: boolean;
}

export interface ILoyaltyLevel {
  loyaltyPointsNeeded: number;
  packId: string;
  pack?: IPack;
}

export interface ILoyaltyByLevel extends Loyalty {
  levels: ILoyaltyLevel[];
}

export interface ILoyaltyByDiscount extends Loyalty {
  loyaltyPointsNeeded: number;

  discount: number;

  automatic: boolean;
}

export type ILoyalty = ILoyaltyByDiscount | ILoyaltyByLevel;

export const isLevelLoyalty = (object: ILoyalty): object is ILoyaltyByLevel => {
  return object?.type === LoyaltyType.LEVEL;
};

export const isDiscountLoyalty = (object: ILoyalty): object is ILoyaltyByDiscount => {
  return object?.type === LoyaltyType.DISCOUNT;
};
